import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=560cabaf&"
import script from "./LayoutFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports